import { useCallback } from 'react';
import { datadogRum } from '@datadog/browser-rum';
export function useCreditoPjTracking() {
    const trackCreditoPjView = useCallback((view) => {
        datadogRum.startView({ name: view });
    }, []);
    const trackCreditoPjAction = useCallback((action, context) => {
        datadogRum.addAction(action, context);
    }, []);
    return { trackCreditoPjView, trackCreditoPjAction };
}
